import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { clone } from 'lodash';
import { Info } from '../../../core/common';
import { addItemToQuoteLbl, CartItem, IAddCartToQuoteBody, IApiResultResponse, IItemList, IMasterData, IQuote, Quote } from '../../../core/models';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { MasterDataService } from '../../../core/services/master-data.service';
import { QuoteService } from '../../../core/services/quote.service';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-add-item-to-quote',
  templateUrl: './add-item-to-quote.component.html',
  styleUrls: ['./add-item-to-quote.component.scss']
})
export class AddItemToQuoteComponent implements OnInit {

  @Input() inputQuoteData: any;
  @Output() addToQuoteCompleteEvent = new EventEmitter<any>();
  // newQuote: { jobName: any; quoteCommonId: string; totalItemCountInQuote: number; displayExistingQuote: string; };

  constructor(private formBuilder: FormBuilder,
    private quoteService: QuoteService,
    private masterService: MasterDataService,
    private userService: UserService, private router: Router, private languageTranslationService: LanguageTranslationService) {
  }

  public inProgressMessage: boolean;
  public infoMessage: Info = new Info();
  public infoMessageNewQuote: Info = new Info();
  addQuoteForm: FormGroup;
  quoteData: Quote[];
  public marketSegments: IMasterData[] = [];
  quoteDropdownData: Quote[];
  selectedQuoteCommonId: string = "";
  selectedJobName: string = "";
  public saveInProcess: boolean;
  public addQuoteInProcess: boolean;
  public item: Quote;
  public quoteLblTxt: addItemToQuoteLbl;
  //public quoteItems: Quote[];
  createQuoteSuccess: boolean;
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.addQuoteForm = this.formBuilder.group({
      itemId: new FormControl(),
      quote: new FormControl(),
      jobName: new FormControl(),
      marketSegment: new FormControl(),
      leed: new FormControl(false)
    });

    this.getQuoteDropdownData();

    this.getMarketSegmentDropDownData();

  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "quoteLbl" },
      { controlName: "jobNameLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "leedLbl" },
      { controlName: "addQuoteTitleLbl" },
      { controlName: "addExistingQuoteLbl" },
      { controlName: "addLbl" },
      { controlName: "newQuoteLbl" },
      { controlName: "orLbl" },
      { controlName: "createLbl" },
      { controlName: "cancelLbl" },
      { controlName: "gotoQuoteLbl" },
      { controlName: "successLbl1" },
      { controlName: "successLbl2" },

    ];
    const componentName = "addquote";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.quoteLblTxt = response[response.length - 1];
    }
  }

  //#endregion
  public quoteDialog = {
    opened: false,
    quoteLbl: 'Existing Quotes',
    jobNameLbl: "Job Name",
    marketSegmentLbl: "Market Segment",
    leedLbl: "LEED",
    addQuoteTitleLbl: "Add Item to Quote",
    addExistingQuoteLbl: "Add Item to Existing Quote",
    addLbl: "Add",
    orLbl: "OR",
    newQuoteLbl: "Create New Quote and Add Item to Quote",
    createLbl: "Create & Add",
    cancelLbl: "Cancel",
    gotoQuoteLbl: "Go To Quote",
    successLbl1: "All cart items successfully added to the selected quote",
    successLbl2: "Item added to quote successfully!",
    isSubmitted: false,
    isEmptyJobName: false,
    isEmptyMarketSegment: false,
    isEmptyQuote: false,
  }

  sendMessageToCallingComponent() {
    this.addToQuoteCompleteEvent.emit(this.inputQuoteData);
  }

  //market segment data not getting populated
  getMarketSegmentDropDownData() {
    this.masterService.getMarketSegments().then(r => {
      this.marketSegments = r;
    });
  }

  getQuoteDropdownData() {
    this.quoteService.getKdQuotesWithItemCount().subscribe((response: Array<Quote>) => {
      if (response) {
        this.quoteDropdownData = response;
        this.quoteData = this.quoteDropdownData;
        if (this.inputQuoteData.quoteCommonId) {
          this.selectedQuoteCommonId = this.inputQuoteData.quoteCommonId;
          this.item = this.quoteDropdownData.find((s) => s.quoteCommonId.toLowerCase().indexOf(this.inputQuoteData.quoteCommonId) !== -1);
        }
      }
    }, error => {
        //dont do anything
    })
  }


  resetQuoteDialog() {
    this.infoMessage = new Info();
    this.infoMessageNewQuote = new Info();
    this.saveInProcess = false;
    this.addQuoteForm.reset();
    this.quoteDialog.isEmptyJobName = false;
    this.quoteDialog.isEmptyMarketSegment = false;
    this.quoteDialog.isEmptyQuote = false;
    this.quoteDialog.isSubmitted = false;
    this.resetForm();
  }

  handleQuoteFilter(value) {
    this.quoteData = this.quoteDropdownData.filter((s) => s.jobName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  saveItemToQuote() {
    this.createQuoteSuccess = false;
    const selectedQuoteId = this.addQuoteForm.controls.quote.value ? this.addQuoteForm.controls.quote.value.quoteCommonId : "";
    if (!selectedQuoteId) {
      this.quoteDialog.isEmptyQuote = true;
      return;
    }

    this.infoMessage = new Info();
    this.infoMessageNewQuote = new Info();
    this.inProgressMessage = true;
    this.addQuoteInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    var selectedQuote = this.quoteDropdownData.find((s) => s.quoteCommonId === selectedQuoteId);
    if (this.inputQuoteData.mode === "item-to-quote") {

      const body = clone(this.inputQuoteData);
      body.quoteCommonId = selectedQuoteId;
      body.ItemNumber = this.inputQuoteData.itemNumber;
      body.Size = this.inputQuoteData.size;
      body.Finish = this.inputQuoteData.finish;
      body.FinishValue = this.inputQuoteData.finishValue;
      body.Quantity = this.inputQuoteData.quantity;
      body.paint = this.inputQuoteData.paint;
      body.lineNo = Number(selectedQuote.totalItemCountInQuote) + 1;
      body.customerNumber = this.userService.readUserObject.customerNumber;

      this.addItem(body, this.infoMessage);
    } else {
      const body: IAddCartToQuoteBody = {
        quoteCommonId: selectedQuoteId,
        userName: this.userService.readUserObject.userName,
        customerNumber: this.userService.readUserObject.customerNumber,
      }
      this.addCartItems(body, this.infoMessage);
    }


  }

  closeQuoteModal() {
    this.inputQuoteData.isOpened = false;
    this.sendMessageToCallingComponent();
    return;

  }

  public validateAddQuoteForm(): boolean {
    let isValid = true;
    if (!this.quoteDialog) {
      return;
    }
    var controls = this.addQuoteForm.controls;
    if (this.quoteDialog.isSubmitted) {
      if (controls.jobName.value) {
        this.quoteDialog.isEmptyJobName = false;
      } else {
        this.quoteDialog.isEmptyJobName = true;
        isValid = false;
      }
      if (controls.marketSegment.value) {
        this.quoteDialog.isEmptyMarketSegment = false;
      } else {
        this.quoteDialog.isEmptyMarketSegment = true;
        isValid = false;
      }
    }
    return isValid;
  }

  quoteDropdownChange(event: Quote) {
    this.quoteDialog.isEmptyQuote = false;
    this.createQuoteSuccess = false;
    this.item = this.quoteDropdownData.find((s) => s.quoteCommonId.toLowerCase().indexOf(event.quoteCommonId.toLowerCase()) !== -1);
  }

  createAndSaveItemToQuote() {
    this.quoteDialog.isSubmitted = true;
    if (!this.validateAddQuoteForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.infoMessageNewQuote = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessageNewQuote.genericInProgress = this.infoMessageNewQuote.inProgressMessage;
    console.log(this.addQuoteForm.controls)
    const controls = this.addQuoteForm.controls;
    const body = {
      jobName: controls.jobName.value,
      marketSegment: controls.marketSegment.value ? controls.marketSegment.value.name : "",
      marketSegmentId: controls.marketSegment.value ? controls.marketSegment.value.value : "",
      leed: controls.leed ? controls.leed.value : false,
      //userId: this.userService.readUserObject.userId,
      customerNumber: this.userService.readUserObject.customerNumber,
    }
    this.quoteService.createQuote(body).subscribe((response: IQuote) => {
      console.log(response);
      this.createQuoteSuccess = false;
      //this.infoMessageNewQuote.genericInProgress = "";
      //this.saveInProcess = false;
      if (response) {
        //this.selectedQuoteCommonId = response.quoteCommonId;
        //this.selectedJobName = this.addQuoteForm.controls.jobName.value;
        this.item = response;
        this.item.quoteDisplayName = response.jobNumber + " - " + response.revision + " : " + response.jobName;
        //this.newQuote = ({
        //  jobName: this.addQuoteForm.controls.jobName.value,
        //  quoteCommonId: response.quoteCommonId,
        //  totalItemCountInQuote: 0,
        //  displayExistingQuote: response.jobNumber + " - " + response.revision + " : " + response.jobName
        //});
        this.quoteData.push(this.item);
        if (this.inputQuoteData.mode === "item-to-quote") {

          const body = clone(this.inputQuoteData);
          body.quoteCommonId = response.quoteCommonId;
          body.ItemNumber = this.inputQuoteData.itemNumber;
          body.Size = this.inputQuoteData.size;
          body.Finish = this.inputQuoteData.finish;
          body.FinishValue = this.inputQuoteData.finishValue;
          body.Quantity = this.inputQuoteData.quantity;
          body.paint = this.inputQuoteData.paint;
          body.lineNo = 1;
          body.customerNumber = this.userService.readUserObject.customerNumber;


          this.addItem(body, this.infoMessageNewQuote);
        } else {
          const body: IAddCartToQuoteBody = {
            quoteCommonId: response.quoteCommonId,
            userName: this.userService.readUserObject.userName,
            customerNumber: this.userService.readUserObject.customerNumber,
          }
          this.addCartItems(body, this.infoMessageNewQuote);
        }
      }
      else {
        this.infoMessageNewQuote.genericInProgress = "";
        this.inProgressMessage = false;
        this.saveInProcess = false;
        this.infoMessageNewQuote.genericError = this.infoMessageNewQuote.errorMessage;
      }
    }, error => {
      this.infoMessageNewQuote.genericInProgress = "";
      this.inProgressMessage = false;
      this.saveInProcess = false;
      this.infoMessageNewQuote.genericError = this.infoMessageNewQuote.errorMessage;
    });
  }
  showItemAddedSuccess = false;
  addCartItems(body: IAddCartToQuoteBody, infoMessage: Info) {
    this.createQuoteSuccess = false;
    this.quoteService.addCartItemToKdQuote(body).subscribe((response: any) => {
      infoMessage.genericInProgress = "";
      this.addQuoteInProcess = false;
      this.saveInProcess = false;
      if (response) {
        infoMessage.genericSuccess = "All cart items successfully added to the selected quote";
        this.addQuoteForm.controls.quote.reset();
        this.selectedQuoteCommonId = "";
        this.selectedJobName = "";
        this.resetForm();
        this.createQuoteSuccess = true;
        this.showItemAddedSuccess = true;
        //this.closeQuoteModal();
        // this.goToQuoteDetail();
      } else {
        infoMessage.genericInProgress = "";
        this.inProgressMessage = false;
        this.addQuoteInProcess = false;
        this.saveInProcess = false;
        infoMessage.genericError = infoMessage.errorMessage;
      }
    }, error => {
      infoMessage.genericInProgress = "";
      this.inProgressMessage = false;
      this.addQuoteInProcess = false;
      this.saveInProcess = false;
      infoMessage.genericError = infoMessage.errorMessage;
    });
  }

  addItem(body: any, infoMessage: Info) {
    this.createQuoteSuccess = false;
    if (this.inputQuoteData.itemType === 2) {
      this.quoteService.addConfiguredItemToQuote(body).subscribe((response: any) => {
        infoMessage.genericInProgress = "";
        this.addQuoteInProcess = false;
        this.saveInProcess = false;
        if (response) {
          infoMessage.genericSuccess = "Item added to quote successfully!";
          this.selectedQuoteCommonId = "";
          this.selectedJobName = "";
          this.resetForm();
          //this.createQuoteSuccess = true;
          this.goToQuoteDetail();
          //this.closeQuoteModal();
          //this.showItemAddedSuccess = true;
        } else {
          infoMessage.genericInProgress = "";
          this.inProgressMessage = false;
          this.saveInProcess = false;
          infoMessage.genericError = infoMessage.errorMessage;
        }
      }, error => {
        infoMessage.genericInProgress = "";
        this.inProgressMessage = false;
        this.saveInProcess = false;
        infoMessage.genericError = infoMessage.errorMessage;
      });
    } else {
      //getting 500 from api response serviceX
      this.quoteService.addItemToKdQuote(body).subscribe((response: any) => {
        infoMessage.genericInProgress = "";
        this.addQuoteInProcess = false;
        this.saveInProcess = false;
        if (response) {
          infoMessage.genericSuccess = "Item added to quote successfully!";
          this.selectedQuoteCommonId = "";
          this.selectedJobName = "";
          this.resetForm();
          this.createQuoteSuccess = true;
          //this.goToQuoteDetail();
          //this.closeQuoteModal();
          //this.showItemAddedSuccess = true;
        } else {
          infoMessage.genericInProgress = "";
          this.inProgressMessage = false;
          this.saveInProcess = false;
          infoMessage.genericError = infoMessage.errorMessage;
        }
      }, error => {
        infoMessage.genericInProgress = "";
        this.inProgressMessage = false;
        this.saveInProcess = false;
        infoMessage.genericError = infoMessage.errorMessage;
      });
    }
  }
  resetForm() {
    this.addQuoteForm.controls.jobName.reset();
    this.addQuoteForm.controls.marketSegment.setValue(null);
    this.addQuoteForm.controls.leed.setValue(false);
    this.showItemAddedSuccess = false;
  }
  goToQuoteDetail(): void {
    this.quoteService.selectedQuoteHeader = this.item;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/manage-quote/kawneerdirect-quotes/quote-detail']); // navigate to same route
    });
  }
}
